import * as React from 'react';
import { ForwardedRef, forwardRef } from 'react';
import { IMaskedInputProps } from '@cian/ui-kit';

import { Input } from '../Input';

type TPhoneProps = Partial<Omit<IMaskedInputProps, 'onChange'>> & {
  onChange?(value: string): void;
};

export const PhoneInput = forwardRef((props: TPhoneProps, ref?: ForwardedRef<HTMLInputElement>) => {
  return <Input ref={ref} mask={'+{7} 000 000 00 00'} lazy {...props} />;
});

PhoneInput.displayName = 'PhoneInput';
